

<template>
    <body>
      <router-view />
    </body>
</template>

<script setup>
</script>

<style>

body { 
  background: linear-gradient(-45deg, rgba(18, 18, 18, 1) 69%, rgba(187, 134, 252, 1) 100%);
  background-attachment: fixed;
}

.primary-font {
  font-family: 'Roboto Mono';
}


@import url('https://fonts.googleapis.com/css2?family=Oswald&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Share+Tech+Mono&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Share+Tech&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@100;300;400;500;700;900&display=swap');


</style>